import { NegativeColors, TextColors } from '@picsart/design-system/foundation/colors';

const TextColorsOptions = {
  white: NegativeColors.text.default,
  gray: TextColors.tint1,
  'dark blue': TextColors.base,
};

export default TextColorsOptions;
